import { FormacaoProvider } from 'Common/Context/Formacao'
import Cabecalho from 'componentes/Cabecalho'
import Rodape from 'componentes/Rodape'
import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import styles from './PaginaBase.module.css'
import { motion } from 'framer-motion'
import { BiArrowToTop } from 'react-icons/bi'

export default function PaginaBase() {

    const [aparece, setAparece] = useState(false)

    function mostraOuEsconde() {
        if (window.scrollY > 1000) {
            setAparece(true)
        }
        if (window.scrollY < 1000) {
            setAparece(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', () =>
            mostraOuEsconde()
        )
    }, [])

    function voltarAoInicio() {
        window.scrollTo(0, 0)
    }



    return (
        <>
            <Cabecalho />
            <main>
                <FormacaoProvider>
                    <Outlet />
                </FormacaoProvider>
            </main>
            <Rodape />
            {aparece ? <BiArrowToTop className={styles.botao} size={60} onClick={voltarAoInicio} /> : ''}
        </>
    )
}
